import type HttpClient from "../../tastyworks/http"
import {
  BaseResponse,
  parseErrorContainer,
  updateSingleResponse,
  type SingleResponse,
} from "../../tastyworks/response"
import {
  MOBILE_CONFIRMATION_DESER,
  MobileConfirmation,
} from "../../tastyworks/user"

export class MobileConfirmationService {
  constructor(
    private readonly userMeClient: HttpClient,
    private readonly customerMeClient: HttpClient
  ) {}

  async requestConfirmationCode(
    mobilePhoneNumber: string
  ): Promise<SingleResponse<MobileConfirmation>> {
    const helper = await this.userMeClient.postJson("mobile/confirmation", {
      "mobile-number": mobilePhoneNumber,
    })
    return updateSingleResponse(
      helper,
      new MobileConfirmation(),
      MOBILE_CONFIRMATION_DESER.update
    )
  }

  async validateConfirmationCode(
    confirmationCode: string
  ): Promise<BaseResponse> {
    this.customerMeClient.session.oneTimePassword = confirmationCode
    const helper = await this.customerMeClient.patch("mobile-confirmation", {})

    const response = new BaseResponse()
    parseErrorContainer(helper, response)

    return response
  }

  /**
   * User-level counterpart to {@link validateConfirmationCode}, for callers that
   * have a session but no customer yet (e.g. account opening), or that need the
   * unified-credentials route's force-primary control (cascading MFA add flow —
   * the customer-level legacy route does not support the param).
   */
  async validateUserConfirmationCode(
    confirmationCode: string,
    { forcePrimary }: { forcePrimary?: boolean } = {}
  ): Promise<SingleResponse<MobileConfirmation>> {
    this.userMeClient.session.oneTimePassword = confirmationCode
    const helper = await this.userMeClient.patch(
      "mobile/confirmation",
      forcePrimary === undefined ? {} : { "force-primary": forcePrimary }
    )

    return updateSingleResponse(
      helper,
      new MobileConfirmation(),
      MOBILE_CONFIRMATION_DESER.update
    )
  }

  async updateMobileConfirmation(
    mobilePhoneNumber: string,
    password: string
  ): Promise<SingleResponse<MobileConfirmation>> {
    const helper = await this.userMeClient.put("mobile/confirmation", {
      "current-password": password,
      "mobile-number": mobilePhoneNumber,
    })
    return updateSingleResponse(
      helper,
      new MobileConfirmation(),
      MOBILE_CONFIRMATION_DESER.update
    )
  }
}
